var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 33,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M30.703 9.987H2.326c-.01.135-.019.25-.019.366v16.726c0 1.836 1.106 3.22 2.826 3.547.289.057.596.057.894.057h11.045c.74 0 1.202.346 1.317.962a1.14 1.14 0 0 1-1 1.336c-.096.01-.192.01-.288.01-3.768 0-7.536.009-11.305 0-2.806-.01-5.085-1.817-5.68-4.528-.106-.471-.126-.971-.126-1.461C0 21.205 0 15.399 0 9.593V5.854c.02-3 2-5.325 4.95-5.796C5.259.01 5.576 0 5.884 0h21.234c3.028 0 5.354 1.97 5.835 4.95.048.27.048.548.048.827 0 3.788 0 7.575.01 11.372 0 .394-.096.73-.404.99-.644.558-1.663.23-1.855-.596a2.491 2.491 0 0 1-.048-.538V9.987Zm-.058-2.345c0-.856.106-1.701-.02-2.518-.278-1.73-1.7-2.817-3.546-2.817H6.142c-.182 0-.355 0-.538.01-1.096.048-1.98.528-2.634 1.403a3.175 3.175 0 0 0-.663 1.903c-.01.673 0 1.356 0 2.029 9.488-.01 18.927-.01 28.338-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M21.561 23.06a74.816 74.816 0 0 1-.904-.855c-.509-.51-.528-1.192-.067-1.673.471-.48 1.173-.461 1.702.048.288.289.538.731.884.818.308.076.702-.26 1.077-.356.317-.087.422-.23.394-.548-.03-.298-.01-.596-.01-.894.02-.663.48-1.144 1.125-1.154.634-.01 1.134.452 1.172 1.115.02.375.01.74 0 1.116-.01.182.058.269.24.326.337.106.674.25.99.414.174.086.28.067.405-.068.23-.25.47-.48.711-.71.49-.472 1.192-.472 1.644-.01.451.46.451 1.143-.03 1.643-.24.25-.499.49-.73.74-.057.058-.096.193-.067.27.183.451.384.893.606 1.374h1.115c.692.01 1.182.471 1.192 1.125.01.644-.471 1.144-1.154 1.173-.394.019-.788 0-1.173 0-.201.48-.384.942-.615 1.49.24.22.538.47.808.74.5.51.519 1.201.057 1.672-.47.471-1.163.452-1.672-.038-.212-.212-.414-.433-.644-.635-.068-.067-.212-.115-.298-.086-.231.086-.452.221-.683.317-.22.096-.442.163-.692.25v1.105c-.01.731-.49 1.24-1.153 1.24-.673 0-1.135-.5-1.144-1.25v-1.066c-.471-.212-.923-.423-1.384-.615-.068-.03-.202.029-.26.086-.25.23-.471.471-.721.711-.51.49-1.211.5-1.673.02-.451-.462-.432-1.154.039-1.644.221-.23.452-.471.692-.683.154-.134.173-.24.077-.432a5.642 5.642 0 0 1-.404-.961c-.058-.202-.154-.26-.356-.26-.336.01-.672.01-1.009 0-.711-.02-1.201-.5-1.201-1.163 0-.673.49-1.134 1.21-1.134.395 0 .875.125 1.164-.048.26-.154.317-.654.48-.99.058-.154.154-.308.26-.52Zm6.892 2.74a2.687 2.687 0 0 0-2.662-2.72c-1.48-.02-2.701 1.201-2.701 2.682 0 1.451 1.191 2.672 2.633 2.681 1.51.01 2.72-1.163 2.73-2.643Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M14.217 13.496c-.01.049-.01.173-.048.289-.779 2.355-1.557 4.7-2.346 7.046-.173.51-.615.798-1.124.788-.48-.01-.913-.317-1.038-.788-.058-.221-.077-.49-.01-.702a674.2 674.2 0 0 1 2.345-7.055c.183-.558.731-.866 1.27-.77.557.097.941.548.951 1.192Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M7.383 16.966c.5.49.98.97 1.46 1.442.347.336.481.74.347 1.21-.221.79-1.212 1.116-1.817.558a62.03 62.03 0 0 1-2.519-2.508c-.403-.433-.346-1.087.087-1.529.769-.788 1.548-1.567 2.336-2.336a1.149 1.149 0 0 1 1.615-.01c.442.433.461 1.145.019 1.616-.413.432-.846.845-1.269 1.278-.067.067-.144.154-.26.279Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M16.418 16.947a114.67 114.67 0 0 1-1.528-1.528c-.375-.385-.452-.913-.212-1.356a1.09 1.09 0 0 1 1.202-.586c.23.048.48.173.654.336.778.75 1.538 1.51 2.288 2.279.5.5.509 1.163.019 1.663a174.84 174.84 0 0 1-2.307 2.316c-.49.48-1.192.471-1.644.02-.452-.452-.452-1.154.02-1.644.24-.25.49-.49.74-.74.23-.231.48-.471.768-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M17.649 6.132a1.161 1.161 0 0 1-1.144-1.153c0-.644.529-1.163 1.173-1.154.624.01 1.134.539 1.124 1.163-.01.635-.529 1.154-1.153 1.144Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M27.242 4.97a1.14 1.14 0 0 1-1.125 1.162c-.634.01-1.182-.528-1.172-1.153 0-.625.519-1.144 1.153-1.144.625 0 1.144.51 1.144 1.134Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M20.734 4.979c0-.635.51-1.144 1.144-1.144.625 0 1.154.519 1.154 1.134a1.161 1.161 0 0 1-1.163 1.163 1.14 1.14 0 0 1-1.135-1.153Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 27.269,
    x2: 5.807,
    y1: 2.587,
    y2: 28.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 30.478,
    x2: 21.004,
    y1: 19.588,
    y2: 31.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 13.416,
    x2: 7.933,
    y1: 13.019,
    y2: 16.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 8.431,
    x2: 3.887,
    y1: 14.015,
    y2: 17.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 18.392,
    x2: 13.855,
    y1: 14.003,
    y2: 17.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 18.403,
    x2: 16.901,
    y1: 4.006,
    y2: 5.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 26.843,
    x2: 25.348,
    y1: 4.015,
    y2: 5.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 22.633,
    x2: 21.138,
    y1: 4.015,
    y2: 5.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h33.01v33H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend);
export default __webpack_public_path__ + "static/media/backend.b5a546dafad9d6b9c034b154e61dc734.svg";
export { ForwardRef as ReactComponent };